import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

export const useStyles = (hideSteps?: boolean) => {
  return {
    overlayCSS: {
      mixBlendMode: "normal" as const,
      backgroundColor: "transparent",
      pointerEvents: "none" as const
    },

    tutorialTooltipCSS: {
      padding: "16px",
      backgroundColor: colors.gray700,
      width: "312px",
      borderRadius: "12px",
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0.1px",
      color: colors.white
    },
    tooltipText: {
      marginBottom: "8px",
      fontWeight: 500,
      display: "flex",
      "span:first-of-type": {
        color: hideSteps ? colors.white : colors.textDisabled,
        marginRight: "8px"
      },
      "span:last-of-type": {
        marginRight: "auto"
      }
    },
    closeIconCSS: {
      height: "20px",
      cursor: "pointer"
    },
    tooltipContent: {
      marginBottom: "16px",
      fontWeight: 400,
      whiteSpace: "pre-line"
    },
    buttonSpacing: {
      display: "flex",
      gap: "8px"
    },
    previousBtnCSS: {
      flex: "0 0 84px"
    },
    nextBtnCSS: {
      flex: "1"
    },
    companyCardAnimationCSS: {
      height: "156px",
      overflow: "hidden",
      borderRadius: "8px",
      marginBottom: "16px",
      "& > svg": {
        transform: "unset !important"
      }
    }
  } as CSSObject;
};
